import { Link } from "react-router-dom";
import { AiOutlineShoppingCart } from "react-icons/ai";
import { CgProfile } from "react-icons/cg";
import { useSelector } from "react-redux";
import {useContext} from 'react';
import UserContext from "../utils/UserContext"
import {logOut} from "../utils/authHelper";

const Sidebar = () => {

    const {user} = useContext(UserContext);

    const logoutHandler = async () => {
      await logOut();
    };

    const cartItems = useSelector(store => store.cart.items);
    return (
      <ul className="absolute z-10 top-20 left-0 w-64 py-2 bg-white font-semibold border-r-4 border-cyan-200 shadow-md rounded-b-md">
        <li className="w-1/3 mx-auto py-4 hover:text-cyan-500">
          <Link to="/">Home</Link>
        </li>
        <li className="w-1/3 mx-auto py-4 hover:text-cyan-500">
          <Link to="/instamart">Instamart</Link>
        </li>
        <li className="w-1/3 mx-auto py-4 hover:text-cyan-500">
          <Link to="/about">About</Link>
        </li>
        {/* <li className="w-1/3 mx-auto py-4 hover:text-cyan-500">
          <Link to="/contact">Contact Us</Link>
        </li> */}
        <li className="w-1/3 mx-auto py-4 hover:text-cyan-500">
          <Link to="/help">Help</Link>
        </li>
        <li className="w-1/3 mx-auto py-4 hover:text-cyan-500">
          <Link to="/cart" className="flex text-xl">
            <AiOutlineShoppingCart className="cart-icon" />
            <sup>{cartItems.length}</sup>
          </Link>
        </li>
        <li className="flex items-center w-1/3 mx-auto py-4 hover:text-cyan-500 text-xl">
          <CgProfile />
          <span className="text-sm rounded-full text-cyan-500 bg-cyan-200 px-2">
            {user.name.slice(0,7)}
          </span>
        </li>
        <li className="w-1/3 mx-auto py-4 hover:text-cyan-500">
          {user.name !== "" ? (
            <Link to="/" onClick={logoutHandler}>
              Logout
            </Link>
          ) : (
            <Link to="/login">Login</Link>
          )}
        </li>
      </ul>
    );
}

export default Sidebar;